var _style, _defs, _g, _g2, _defs2, _g3, _g4, _g5, _defs3, _g6, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftCam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180.4 170.7",
    style: {
      enableBackground: "new 0 0 180.4 170.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000047030726475465184280000009883820108374776713_);}\r\n\t.st1{fill:#525660;}\r\n\t.st2{fill:#95B4CF;}\r\n\t.st3{clip-path:url(#SVGID_00000148621871129037792610000009066933055680097441_);}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{opacity:0.5;fill:#525660;}\r\n\t.st6{fill:none;}\r\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#6A6A65;}\r\n\t.st8{clip-path:url(#SVGID_00000075163804628049405890000005829810125742357410_);}\r\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:#735F5D;}\r\n\t.st10{clip-path:url(#SVGID_00000137844232258903076690000009691162268838264750_);}\r\n\t.st11{display:none;}\r\n\t.st12{display:inline;}\r\n\t.st13{clip-path:url(#SVGID_00000012432024149094641930000002429601016601639338_);}\r\n\t.st14{clip-path:url(#SVGID_00000171685893740514152880000010012021529039688097_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Capa_1_copia"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 48.3,
    width: 49,
    height: 49
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083800684193495957990000017425497521741695918_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Video_camera_front_00000150065109764905239300000009890980484582451590_",
    style: {
      clipPath: "url(#SVGID_00000083800684193495957990000017425497521741695918_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_00000121245431179629513180000001763137297479085718_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_00000062155476632937548630000000431476953343722412_",
    className: "st1",
    d: "M36.8,69.7v-9.2c0-2.2-1.8-4.1-4.1-4.1 H8.2c-2.2,0-4.1,1.8-4.1,4.1v24.5c0,2.2,1.8,4.1,4.1,4.1h24.5c2.2,0,4.1-1.8,4.1-4.1V76l6.4,6.4c0.6,0.7,1.7,0.2,1.7-0.7V64.1 c0-0.9-1.1-1.4-1.7-0.7L36.8,69.7z M20.4,64.7c2.2,0,4.1,1.8,4.1,4.1s-1.8,4.1-4.1,4.1s-4.1-1.8-4.1-4.1S18.2,64.7,20.4,64.7z  M28.6,81H12.3v-1.2c0-1.7,1-3.1,2.5-3.8c1.7-0.8,3.7-1.2,5.7-1.2s3.9,0.4,5.7,1.2c1.5,0.7,2.5,2.1,2.5,3.8V81z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M160.2,62.8h-35.4v59.6l36.1,18.7c0.6-0.1,1-0.6,1-1.1V64.4C161.8,63.5,161.1,62.8,160.2,62.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.4,87.7v50.7c0,0.5,0.4,0.9,0.9,0.9h32.3v-34.7l0-4.5l4,2.1v41.2H53.3c-2.7,0-4.9-2.2-4.9-4.9V81.1 l4.1,2.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.7,119.1l3.9,2v22.3H85.5v-43.3l3.6,2.9l0.5,3.8v32.6h33v-15.7L122.7,119.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M159.8,129.9l1.8,9.1c1.5,1,1.2,2.3,1.1,2.7c-0.3,1-1.3,1.6-2.5,1.6h-37.4v-24.2l3.7,2.4l0.3,4.2v13.6h33.6 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "124.6,122.3 124.6,141.3 124.8,141.3 124.8,122.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "126.8,143.4 122.6,143.4 122.6,119 126.8,121.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.6,119V64.8h-33v37.3l-4,2.5V60.8h41.1v64.9L122.6,119z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M159.8,138.3V64.8h-33v56.4l0,4.6l-4-2.1V60.8h37.4c2,0,3.7,1.6,3.7,3.7V140c0,1.6-1.1,2.9-2.7,3.1 l-1.4-0.4V138.3z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_1_copia_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000067193835929795450930000016037745916859325849_",
    y: 48.3,
    width: 49,
    height: 49
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000100367478579202467030000009687571310700658816_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067193835929795450930000016037745916859325849_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Video_camera_front_00000182530682556373603890000006325140105293465740_",
    style: {
      clipPath: "url(#SVGID_00000100367478579202467030000009687571310700658816_)"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_00000010294090032852319280000000941834113792730525_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_00000020379439532286885820000007543523716956710309_",
    className: "st1",
    d: "M36.8,69.7v-9.2c0-2.2-1.8-4.1-4.1-4.1 H8.2c-2.2,0-4.1,1.8-4.1,4.1v24.5c0,2.2,1.8,4.1,4.1,4.1h24.5c2.2,0,4.1-1.8,4.1-4.1V76l6.4,6.4c0.6,0.7,1.7,0.2,1.7-0.7V64.1 c0-0.9-1.1-1.4-1.7-0.7L36.8,69.7z M20.4,64.7c2.2,0,4.1,1.8,4.1,4.1s-1.8,4.1-4.1,4.1s-4.1-1.8-4.1-4.1S18.2,64.7,20.4,64.7z  M28.6,81H12.3v-1.2c0-1.7,1-3.1,2.5-3.8c1.7-0.8,3.7-1.2,5.7-1.2s3.9,0.4,5.7,1.2c1.5,0.7,2.5,2.1,2.5,3.8V81z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.5,100.1l4,2.1v41.2H53.3c-2.7,0-4.9-2.2-4.9-4.9V81.1l4,2.1v4.5v50.7c0,0.5,0.4,0.9,0.9,0.9h32.3v-34.7 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "124.6,122.3 124.6,141.3 124.8,141.3 124.8,122.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "126.8,143.4 122.6,143.4 122.6,119 126.8,121.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M87.6,62.8H51.9c-0.8,0-1.5,0.7-1.5,1.5v20.1l37.2,19V62.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.5,100.1V64.8H52.4v18.3l0,9.5l-4-2.1V64.4c0-2,1.6-3.6,3.6-3.6h37.7v45.9l-4-2.1V100.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "122.6,121.3 124.6,123.3 124.6,63.8 87.6,63.8 86.8,102.5 90.2,104.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.6,109V64.8h-33v43l-4,6.8v-4.5V60.8h41.1v64.9l-4-2.1"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M173.3,64.9v74.6c0,1.7-1.3,3-3,3h0c-1.7,0-3-1.3-3-3V64.9c0-1.7,1.3-3,3-3h0C172,61.9,173.3,63.3,173.3,64.9 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 165.8,
    y: 64.9,
    className: "st6",
    width: 15,
    height: 14
  })), /*#__PURE__*/React.createElement("rect", {
    x: 172.4,
    y: 75.3,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.4,
    y: 70.6,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.4,
    y: 66,
    className: "st9",
    width: 1.5,
    height: 2.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 165.8,
    y: 78.9,
    className: "st6",
    width: 15,
    height: 14
  })), /*#__PURE__*/React.createElement("rect", {
    x: 172.4,
    y: 89.3,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.4,
    y: 84.6,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.4,
    y: 80,
    className: "st9",
    width: 1.5,
    height: 2.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 165.8,
    y: 92.9,
    className: "st6",
    width: 15,
    height: 14
  })), /*#__PURE__*/React.createElement("rect", {
    x: 172.4,
    y: 103.3,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.4,
    y: 98.6,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.4,
    y: 94,
    className: "st9",
    width: 1.5,
    height: 2.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 165.8,
    y: 106.9,
    className: "st6",
    width: 15,
    height: 14
  })), /*#__PURE__*/React.createElement("rect", {
    x: 172.4,
    y: 117.3,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.4,
    y: 112.6,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.4,
    y: 108,
    className: "st9",
    width: 1.5,
    height: 2.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 165.8,
    y: 120.9,
    className: "st6",
    width: 15,
    height: 14
  })), /*#__PURE__*/React.createElement("rect", {
    x: 172.4,
    y: 131.3,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.4,
    y: 126.6,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.4,
    y: 122,
    className: "st9",
    width: 1.5,
    height: 2.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M165.8,134.9v3.5v0.9l0,0.2c0-0.1,0-0.2,0-0.3c0-0.2,0-0.4,0.1-0.6c0.2-0.9,0.7-1.7,1.3-2.3 c0.6-0.6,1.4-1,2.3-1.2c0.9-0.2,1.7-0.1,2.6,0.3c0.8,0.3,1.5,0.9,2,1.7c0.5,0.7,0.8,1.6,0.7,2.5h-15c0,2,0.6,4.1,1.7,5.8 c1.1,1.7,2.7,3.1,4.6,3.9c1.9,0.8,4,1,6,0.7c2-0.4,3.9-1.3,5.4-2.7c1.5-1.4,2.5-3.2,3-5.3c0.1-0.5,0.2-1,0.2-1.5 c0-0.3,0-0.5,0-0.8l0-0.3v-0.9v-3.5H165.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M169.1,142.8l0.5-1.4c-0.6-0.2-1-0.7-1.2-1.2l-1.4,0.5C167.4,141.6,168.1,142.4,169.1,142.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M173.6,140.8l-1.4-0.6c-0.2,0.5-0.7,1-1.2,1.2l0.5,1.4C172.4,142.5,173.3,141.7,173.6,140.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.4,
    y: 135.9,
    className: "st9",
    width: 1.5,
    height: 2.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 159.8,
    y: 125.5,
    className: "st6",
    width: 15,
    height: 14
  })), /*#__PURE__*/React.createElement("rect", {
    x: 166.8,
    y: 126.5,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.8,
    y: 131.2,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.8,
    y: 135.8,
    className: "st9",
    width: 1.5,
    height: 2.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 159.8,
    y: 111.5,
    className: "st6",
    width: 15,
    height: 14
  })), /*#__PURE__*/React.createElement("rect", {
    x: 166.8,
    y: 112.5,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.8,
    y: 117.2,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.8,
    y: 121.8,
    className: "st9",
    width: 1.5,
    height: 2.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 159.8,
    y: 97.5,
    className: "st6",
    width: 15,
    height: 14
  })), /*#__PURE__*/React.createElement("rect", {
    x: 166.8,
    y: 98.5,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.8,
    y: 103.2,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.8,
    y: 107.8,
    className: "st9",
    width: 1.5,
    height: 2.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 159.8,
    y: 83.5,
    className: "st6",
    width: 15,
    height: 14
  })), /*#__PURE__*/React.createElement("rect", {
    x: 166.8,
    y: 84.5,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.8,
    y: 89.2,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.8,
    y: 93.8,
    className: "st9",
    width: 1.5,
    height: 2.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 159.8,
    y: 69.5,
    className: "st6",
    width: 15,
    height: 14
  })), /*#__PURE__*/React.createElement("rect", {
    x: 166.8,
    y: 70.5,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.8,
    y: 75.2,
    className: "st9",
    width: 1.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.8,
    y: 79.8,
    className: "st9",
    width: 1.5,
    height: 2.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M174.8,69.5V66v-0.9l0-0.2c0,0.1,0,0.2,0,0.3c0,0.2,0,0.4-0.1,0.6c-0.2,0.9-0.7,1.7-1.3,2.3 c-0.6,0.6-1.4,1-2.3,1.2c-0.9,0.2-1.7,0.1-2.6-0.3c-0.8-0.3-1.5-0.9-2-1.7c-0.5-0.7-0.8-1.6-0.7-2.5h15c0-2-0.6-4.1-1.7-5.8 c-1.1-1.7-2.7-3.1-4.6-3.9c-1.9-0.8-4-1-6-0.7c-2,0.4-3.9,1.3-5.4,2.7c-1.5,1.4-2.5,3.2-3,5.3c-0.1,0.5-0.2,1-0.2,1.5 c0,0.3,0,0.5,0,0.8l0,0.3V66v3.5H174.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M171.6,61.6l-0.5,1.4c0.6,0.2,1,0.7,1.2,1.2l1.4-0.5C173.3,62.8,172.5,62,171.6,61.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M167.1,63.6l1.4,0.6c0.2-0.5,0.7-1,1.2-1.2l-0.5-1.4C168.2,61.9,167.4,62.7,167.1,63.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.8,
    y: 65.8,
    className: "st9",
    width: 1.5,
    height: 2.6
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    className: "st11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000023979458104418553110000005786199639345861548_",
    y: 48.3,
    width: 49,
    height: 49
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000087409209471696048690000013404967016346959549_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000023979458104418553110000005786199639345861548_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Video_camera_front",
    style: {
      clipPath: "url(#SVGID_00000087409209471696048690000013404967016346959549_)"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "st1",
    d: "M36.8,69.7v-9.2c0-2.2-1.8-4.1-4.1-4.1H8.2c-2.2,0-4.1,1.8-4.1,4.1v24.5 c0,2.2,1.8,4.1,4.1,4.1h24.5c2.2,0,4.1-1.8,4.1-4.1V76l6.4,6.4c0.6,0.7,1.7,0.2,1.7-0.7V64.1c0-0.9-1.1-1.4-1.7-0.7L36.8,69.7z  M20.4,64.7c2.2,0,4.1,1.8,4.1,4.1s-1.8,4.1-4.1,4.1s-4.1-1.8-4.1-4.1S18.2,64.7,20.4,64.7z M28.6,81H12.3v-1.2 c0-1.7,1-3.1,2.5-3.8c1.7-0.8,3.7-1.2,5.7-1.2s3.9,0.4,5.7,1.2c1.5,0.7,2.5,2.1,2.5,3.8V81z"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.6,143.4H53.3c-2.7,0-4.9-2.2-4.9-4.9V81.1l41.3,21.1V143.4z M52.4,87.7v50.7c0,0.5,0.4,0.9,0.9,0.9 h32.3v-34.7L52.4,87.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.6,143.4H85.5v-43.3l41.1,21V143.4z M89.6,139.3h33v-15.7l-33-16.8V139.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.2,143.4h-37.4v-24.2l38.9,19.9c1.5,1,1.2,2.3,1.1,2.7C162.4,142.7,161.4,143.4,160.2,143.4z  M126.8,139.3h26.6l-26.6-13.6V139.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "124.6,122.3 124.6,141.3 124.8,141.3 124.8,122.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "126.8,143.4 122.6,143.4 122.6,119 126.8,121.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.6,62.8H51.9c-0.8,0-1.5,0.7-1.5,1.5v20.1l37.2,19V62.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.6,106.7L48.3,85.7V64.4c0-2,1.6-3.6,3.6-3.6h37.7V106.7z M52.4,83.2l33.2,16.9V64.8H52.4V83.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "124.6,122.3 124.6,62.8 87.6,62.8 87.6,103.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.6,125.6l-41.1-21V60.8h41.1V125.6z M89.6,102.2l33,16.8V64.8h-33V102.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.2,62.8h-35.4v59.6l36.1,18.7c0.6-0.1,1-0.6,1-1.1V64.4C161.8,63.5,161.1,62.8,160.2,62.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.5,143.3l-37.8-19.6V60.8h37.4c2,0,3.7,1.6,3.7,3.7V140c0,1.6-1.1,2.9-2.7,3.1L160.5,143.3z  M126.8,121.2l33,17.1V64.8h-33V121.2z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftCam);
export default __webpack_public_path__ + "static/media/LeftCam.7eb3a6b9b0ea3e60c6503a04d647de4e.svg";
export { ForwardRef as ReactComponent };